'use client';

import { useEffect, useState } from 'react';

// True once the full-height hero has mostly scrolled out of view. Used to reveal
// the fixed mobile action bar only after the hero's own CTA is gone, so the two
// don't compete while the hero is on screen.
export default function useHeroScrolledAway() {
  const [scrolledAway, setScrolledAway] = useState(false);

  useEffect(() => {
    let frame = 0;

    const onScroll = () => {
      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        setScrolledAway(window.pageYOffset > window.innerHeight * 0.7);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return scrolledAway;
}
